import { usePlace } from 'commons/usePlace'
import * as R from 'ramda'
import { isMediaDeleteKey, toMedia } from '../media/MediaMapper'
import { isEmptyOrNil } from 'libs/empty'
import { removeDoNotTranslateStyle } from 'commons/form'
import { MESSAGE_EXPIRATION_NONE } from './expiration/messageExpiration'
import { createMoment } from 'commons/useMessageExpiration'

export const viewLogo = R.view(R.lensPath(['info', 'logo']))
export const viewName = R.view(R.lensPath(['name']))

export const useNotiToPreviewMapper = () => {
  const place = usePlace()
  return notiToPreviewMapper(place)
}
const notiToPreviewMapper = (place) => (model) => {
  return R.isNil(model)
    ? undefined
    : {
        placeLogo: viewLogo(place),
        placeName: viewName(place),
        title: model.title,
        body: removeDoNotTranslateStyle(model.body),
        description: model.description,
        type: model.notiType,
        priority: model.priority,
        media: R.compose(
          R.ifElse(
            R.anyPass([isEmptyOrNil, R.propEq(isMediaDeleteKey, true)]),
            R.always(undefined),
            R.prop('preview'),
          ),
          R.unless(R.anyPass([R.isNil, R.has('preview')]), toMedia),
          R.prop('media'),
        )(model),
        event: R.mergeRight({ location: model.location }, model.event),
        allowConversation: R.when(
          R.isNil,
          R.always(false),
        )(model.allowConversation),
        isTtsEnabled: R.when(R.isNil, R.always(false))(model.isTtsEnabled),
        timezone: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('id'),
        )(model.timezone),
        frequencySelected: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('frequencySelected'),
        )(model),
        frequencyType: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('frequencyType'),
        )(model),
        duration: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('duration'),
        )(model),
        scheduleStartDate: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('scheduleStartDate'),
        )(model),
        startTimezone: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('startTimezone'),
        )(model),
        scheduleEndDate: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('scheduleEndDate'),
        )(model),
        endTimezone: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('endTimezone'),
        )(model),
        voucher: R.compose(
          R.when(R.isNil, R.always(undefined)),
          R.prop('voucher'),
        )(model),
        topics: R.compose(
          R.when(R.isNil, R.always([])),
          R.prop('topics'),
        )(model),
        expirationDate:
          model.expirationTime === MESSAGE_EXPIRATION_NONE
            ? undefined
            : createMoment(undefined, R.path(['info', 'timezone'], place))
                .add(model.expirationTime, 'seconds')
                .toISOString(),
      }
}
